import { FactoryProvider } from '@angular/core';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { MASTERCARD_TRANSLATIONS, MastercardTranslations } from '@hdms/shared/ui-core';

export const MASTERCARD_TRANSLATIONS_PROVIDER: FactoryProvider = {
  provide: MASTERCARD_TRANSLATIONS,
  deps: [I18NEXT_SERVICE],
  useFactory: (i18NextService: ITranslationService): MastercardTranslations => ({
    noProductDetails: i18NextService.t('product.labels.noProductDetails'),
    noTechnicalDetails: i18NextService.t('product.labels.noTechnicalDetails'),
    compare: i18NextService.t('product.labels.compare'),
    fromPricePrefix: i18NextService.t('product.labels.fromPricePrefix'),
    errorHeadline: i18NextService.t('product.messages.priceError.headline'),
    contactUs: i18NextService.t('product.messages.priceError.contactUs'),
    ariaCompareAdd: i18NextService.t('product.labels.compareAdd', {
      interpolation: { skipOnVariables: true }
    }),
    ariaCompareRemove: i18NextService.t('product.labels.compareRemove', {
      interpolation: { skipOnVariables: true }
    }),
    quantity: i18NextService.t('product.labels.quantity'),
    totalPieces: i18NextService.t('product.labels.totalPieces'),
    selectText: i18NextService.t('product.labels.selectText'),
    selectedText: i18NextService.t('product.labels.selectedText')
  })
};
